import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 18l6 -6l-6 -6v12","key":"svg-0"}],["path",{"d":"M10 18l-6 -6l6 -6v12","key":"svg-1"}]]

const IconCaretLeftRight = createReactComponent('outline', 'caret-left-right', 'CaretLeftRight', __iconNode);

export default IconCaretLeftRight;